export default {
  path: '/reservation-db',
  component: () => import('@/views/reservation-db/Index'),
  redirect: { name: 'hotel-map' },
  children: [
    {
      path: '',
      component: () => import('@/views/reservation-db/hotel-selection/Layout'),
      children: [
        {
          path: 'hotel-map',
          name: 'hotel-map',
          component: () => import('@/views/reservation-db/hotel-selection/Map'),
          meta: {
            title: 'Hotel map',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
        {
          path: 'hotel-selection',
          name: 'hotel-selection',
          component: () => import('@/views/reservation-db/hotel-selection/HotelSelection'),
          meta: {
            title: 'Selection',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
        {
          path: 'hotel-check-price',
          name: 'hotels-check-price',
          component: () => import('@/views/reservation-db/hotel-selection/CheckPrice'),
          meta: {
            title: 'Check accommodation price',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
      ]
    },
    {
      path: 'flights-selection',
      name: 'reservation-db-flights',
      component: () => import('@/views/reservation-db/FlightsSelection'),
      meta: {
        title: 'Flights selection',
        roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
      },
    },
    {
      path: 'database',
      component: () => import('@/views/reservation-db/database/Layout'),
      redirect: { name: 'hotels-database-list' },
      children: [
        {
          path: 'hotels',
          name: 'hotels-database-list',
          component: () => import('@/views/reservation-db/database/hotels/List'),
          meta: {
            title: 'Database',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
        {
          path: 'airlines',
          name: 'airlines-database-list',
          component: () => import('@/views/reservation-db/database/airlines/List'),
          meta: {
            title: 'Database',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
      ]
    },
    {
      path: 'database/hotels/:id',
      component: () => import('@/views/reservation-db/database/hotels/detail/Layout'),
      children: [
        {
          path: '',
          name: 'hotels-database-general',
          component: () => import('@/views/reservation-db/database/hotels/detail/General'),
          meta: {
            title: 'Database',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
        {
          path: 'settings',
          name: 'hotels-database-settings',
          component: () => import('@/views/reservation-db/database/hotels/detail/Settings'),
          meta: {
            title: 'Database',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        }
      ]
    },
    {
      path: 'database/airlines/:id',
      component: () => import('@/views/reservation-db/database/airlines/detail/Layout'),
      children: [
        {
          path: '',
          name: 'hotels-airlines-general',
          component: () => import('@/views/reservation-db/database/airlines/detail/General'),
          meta: {
            title: 'Database',
            roles: ['general_manager', 'sales_manager', 'sales_supervisor', 'safari_supervisor']
          },
        },
      ]
    },
  ]
}